export const SOCIAL_PLATFORMS = {
  GOOGLE: 'google',
};

export const defaultSocialButtons = [SOCIAL_PLATFORMS.GOOGLE];
